/* eslint-disable */
import * as Sentry from "@sentry/vue";
import { browserTracingIntegration } from "@sentry/vue";
import { createApp } from "vue";
import { createHead } from "@vueuse/head";
import { createI18n } from "vue-i18n";
import App from "./App.vue";
import router from "./router";
import "./assets/tailwind.css";
import store from "./store";
import { initPWAInstall } from "./services/pwa";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import { inject } from "@vercel/analytics";
import { injectSpeedInsights } from "@vercel/speed-insights";

import { initAnalytics } from "./services/analytics";

// ── Locale files ──────────────────────────────────────────────────────────────
import en from "./locales/en.json";
import it from "./locales/it.json";

// ── i18n instance ─────────────────────────────────────────────────────────────
const supported = ["en", "it"];
const browser = navigator.language?.split("-")[0]; // "it", "en", "fr", …
console.log("[i18n] Browser language:", browser);
const i18n = createI18n({
	locale:
		localStorage.getItem("trekko_lang") ||
		(supported.includes(browser) ? browser : "en"),
	fallbackLocale: "en",
	legacy: false, // use Composition API mode
	messages: { en, it },
});

// ── Head ──────────────────────────────────────────────────────────────────────
const head = createHead();

const app = createApp(App);

const options = {
	style: { zIndex: 9999 },
};

inject();
injectSpeedInsights();

initAnalytics(router);

Sentry.init({
	app,
	dsn: "https://ae8f375f282e646354bc4d9d35be0fe6@o4509077857042432.ingest.de.sentry.io/4509077913075792",
	integrations: [
		browserTracingIntegration({
			tracePropagationTargets: ["localhost", /^https:\/\/trekko\.xyz/],
		}),
		Sentry.vueIntegration({
			Vue: app,
			attachProps: true,
		}),
	],
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

(async () => {
	try {
		await store.dispatch("tenant/init");
	} catch (e) {
		// ignore
	}

	app
		.use(store)
		.use(router)
		.use(Toast, options)
		.use(head)
		.use(i18n) // ← added
		.mount("#app");
	initPWAInstall();

	// pwa
	if ("serviceWorker" in navigator) {
		window.addEventListener("load", () => {
			navigator.serviceWorker
				.register("/sw.js")
				.then(() => {
					console.log("Trekko service worker registered");
				})
				.catch((error) => {
					console.error("Service worker registration failed:", error);
				});
		});
	}
})();
